<template>
    <span>{{ display_value }}</span>
</template>

<script>
export default {
    name: "DefaultDisplay",
    props: ["value", "defaultValue"],
    computed: {
        display_value() {
            if (this.value) return this.value;
            else return this.defaultValue;
        },
    },
};
</script>

<style scoped></style>
